import { useCallback } from 'react';

export const useFileDownload = () => {
  const downloadBlob = useCallback((blob: Blob, filename: string): void => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }, []);

  const downloadFromUrl = useCallback(
    async (
      url: string,
      filename: string,
      headers?: HeadersInit,
    ): Promise<void> => {
      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error(`Download failed: ${response.statusText}`);
      }

      const blob = await response.blob();
      downloadBlob(blob, filename);
    },
    [downloadBlob],
  );

  return { downloadBlob, downloadFromUrl };
};

export const downloadBlobFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
